import React from 'react';
import { SEOHead } from '../lib/seo';
import { Footerdemo } from './ui/footer-section';

export default function TermsOfService() {
  return (
    <div className="min-h-screen flex flex-col">
      <SEOHead
        title="Terms of Service - User Agreement"
        description="Read our terms of service to understand the rules and guidelines for using AISEOBlogGenerator. Learn about your rights and responsibilities as a user."
        type="website"
        canonicalUrl="https://aiseobloggenerator.com/terms"
      />
      <div className="flex-1 container mx-auto px-4 py-16">
        <h1 className="text-4xl font-bold mb-8">Terms of Service</h1>
        <div className="prose max-w-none">
          <p className="text-lg text-gray-600 mb-6">Last updated: March 15, 2024</p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">1. Agreement to Terms</h2>
            <p>By accessing or using AISEOBlogGenerator.com, you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access the service.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">2. Description of Service</h2>
            <p>AISEOBlogGenerator.com provides an AI-powered content generation service for creating blog posts and marketing content. The service includes:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>AI-powered content generation</li>
              <li>SEO optimization tools</li>
              <li>Content management features</li>
              <li>Custom writing styles</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">3. User Accounts</h2>
            <p>When you create an account with us, you must provide accurate and complete information. You are responsible for maintaining the security of your account and password. You agree to accept responsibility for all activities that occur under your account.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">4. Content Ownership</h2>
            <p>You retain ownership of any content you generate using our service. However, you grant us a license to use, store, and copy that content in connection with providing and improving our service.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">5. Acceptable Use</h2>
            <p>You agree not to use the service to:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Generate spam or malicious content</li>
              <li>Violate any laws or regulations</li>
              <li>Infringe on intellectual property rights</li>
              <li>Generate harmful or discriminatory content</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">6. Termination</h2>
            <p>We may terminate or suspend your account and access to the service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">7. Changes to Terms</h2>
            <p>We reserve the right to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days' notice prior to any new terms taking effect.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">8. Contact Us</h2>
            <p>If you have any questions about these Terms, please contact us at:</p>
            <p>Email: support@aiseobloggenerator.com</p>
          </section>
        </div>
      </div>
      <Footerdemo />
    </div>
  );
}